export const ASSET_VIEW_EVENTS = {
  TAB_SELECTED: "Tab Selected",
  VIEW_SELECTED: "View Selected",
  DISPLAY_METRIC_SELECTED: "Display Metric Selected",
  GROUPING_CHANGED: "Grouping Changed",
  GROUPING_CLEARED: "Grouping Cleared",
  EXPANSION_TOGGLED: "Expansion Toggled",
  SORT_CHANGED: "Sort Changed",
  TABLE_NAVIGATION_CHANGED: "Table Navigation Changed",
} as const
